import axios from "axios";
import { servicePath } from "../../utility/data";

export const usertableData = (accessToken, searchQuery = '', limit, offset) => {
    const headers = {
      'Authorization': `Bearer ${accessToken}`,
    };
    const url = `${servicePath}/users?search=${encodeURIComponent(searchQuery)}&limit=${limit}&offset=${offset}`;
  
    return axios
      .get(url, { headers })
      .then((res) => {
        
        return res;
      })
      .catch((error) => {
        console.log(error);
        return error.response.data;
      });
  };


  export const registeredUser = async (name, email, password, accessToken) => {
    const payload = {
      name,
      email,
      password
    };
  
    try {
      const response = await axios.post(`${servicePath}/users`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error during user registration:', error);
      throw new Error(error.response ? error.response.data.message : 'User registration failed');
    }
  };
  
  export const updateUser = async (updatedFields, accessToken, id) => {
    try {
      const response = await axios.put(`${servicePath}/users/${id}`, updatedFields, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error during user update:', error);
      throw new Error(error.response ? error.response.data.message : 'User update failed');
    }
  };
  

  export const deleteUser = async (accessToken, id) => {
  
    try {
      const response = await axios.delete(`${servicePath}/users/${id}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error during user registration:', error);
      throw new Error(error.response ? error.response.data.message : 'User registration failed');
    }
  };
  

  export const changePassword = async (updatedFields, accessToken, id) => {
    try {
      const response = await axios.post(`${servicePath}/users/change-user-password/${id}`, updatedFields, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error during user update:', error);
      throw new Error(error.response ? error.response.data.message : 'User update failed');
    }
  };